// extracted by mini-css-extract-plugin
export default {"credits-left":"certificates_credits-left__v26Bh"};